import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { apiHalper } from '../../helpers/ApiHelper';
import { jwtDecode } from '../../helpers/jwt_helper';
import {toster_sucess, toster_error} from '../../helpers/toster_helper';
class StatusDetails extends Component {

    constructor(props){
        super(props);
        this.state={
            isNInfo:1,
            chatAlert:1,
            redFlag:0,
            posting:1,
            chatVal:1,
            amountData:null,
            countData:null,
            reviewsData:null,
            banUser:0
        }
    }

    componentDidMount(){
        this.getStatusApi();
    }

    getStatusApi = async () =>{
        try{
            const headers = {
                'Authorization':sessionStorage.getItem('token')
            }
            const queryString = this.props.location.search;
            const urlParams = new URLSearchParams(queryString);
            const type = urlParams.get('type');
            const { id } = this.props.match.params;

            if(type === 'agents'){
                let formData = new FormData();
                formData.append('profile_id', id)
                
                const res = await apiHalper(`getAgentStatus`, 'POST', formData, headers);
                if(res.data.status){
                    const data = jwtDecode(res.data.data);
            
                    this.setState({
                        amountData:data.amount,
                        countData:data.count,
                        reviewsData:data.reviews,
                        banUser: data.auth
                    })
                }else{
                    this.setState({
                        amountData:null,
                        countData:null,
                        reviewsData:null,
                        message:res.data.message
                    })
                }
            }

            if(type === 'clients'){
                // let formData = new FormData();
                // formData.append('profile_id', id)
                
                // const res = await apiHalper(`getAgentStatus`, 'POST', formData, headers);
                // if(res.data.status === true){
                //     const data = jwtDecode(res.data.data);
                //     // console.log(data);
                //     this.setState({
                //         amountData:data.amount,
                //         countData:data.count,
                //         reviewsData:data.reviews
                //     })
                // }else{
                let formData = new FormData();
                formData.append('profile_id', id)
                const res = await apiHalper(`getAgentStatus`, 'POST', formData, headers);
                if(res.data.status){
                    const data = jwtDecode(res.data.data);
                    this.setState({
                        amountData:null,
                        countData:null,
                        reviewsData:null,
                        banUser: data.auth
                        // message:res.data.message
                    })
                }  else {
                    this.setState({
                        amountData:null,
                        countData:null,
                        reviewsData:null
                        // message:res.data.message
                    })
                }  
                    
                // }
            }
        }catch(err){
            console.log(err);
        }
    }

    banUserApi = async (val) =>{
        try{
            const headers = {
                'Authorization':sessionStorage.getItem('token')
            }
            const queryString = this.props.location.search;
            const urlParams = new URLSearchParams(queryString);
            const type = urlParams.get('type');
            const { id } = this.props.match.params;
         
            if(val == 0){
                const res = await apiHalper(`unBanUser/${id}`, 'GET',null, headers);
              
                if(res.data.status === true){
                    toster_sucess("Success on Unbanning user");
                }else{
                    toster_error("Error on Unbanning user");
                }    
            }else if(val == 1){
                const res = await apiHalper(`banUser/${id}`, 'GET',null, headers);
              
                if(res.data.status === true){
                    toster_sucess("Success on banning user");
                }else{
                    toster_error("Error on banning user");
                }
            }
        }catch(err){
            console.log(err);
        }
    }

    radioHandle = (e, val) =>{
        const { name } = e.target;
        switch(name){
            case 'noti_info':
                this.setState({isNInfo:val});
                break;
            case 'chat-alert':
                this.setState({chatAlert:val});
                break;
            case 'red_flag':
                this.setState({redFlag:val});
                break;
            case 'postings':
                this.setState({posting:val});
                break;
            case 'chat':
                this.setState({chatVal:val});
                break;
            case 'ban':
                this.setState({banUser:val});
                this.banUserApi(val);
                break;
            default:
                this.setState({
                    isNInfo:1,
                    chatAlert:1,
                    redFlag:0,
                    posting:1,
                    chatVal:1
                });
                break;
        }
        // console.log(e.target.name);
        // this.setState({
        //     isNInfo:val
        // });
    }

    render() {
        const { isNInfo, chatAlert, redFlag, posting, chatVal, amountData, countData, reviewsData, banUser } = this.state;
 
        return (
            <div className="tab_container">
                <div className="notifica_info">
                    <ul className="noti_ul">
                        <li>
                            <p>Account</p>
                            <div className={"wrap_notialert"} >
                                <input type="radio" id="inactive" name="noti_info" checked={isNInfo === 0} onChange={(e)=>this.radioHandle(e, 0)} />
                                <label htmlFor="inactive">Inactive</label>
                                <input type="radio" id="active" name="noti_info" checked={isNInfo === 1} onChange={(e)=>this.radioHandle(e, 1)} />
                                <label htmlFor="active" >Active</label>
                                <input type="radio" id="hold" name="noti_info" checked={isNInfo === 2} onChange={(e)=>this.radioHandle(e, 2)} />
                                <label htmlFor="hold">Hold</label>
                            </div>
                        </li>
                        <li>
                            <p>Chatting Alert</p>
                            <div className={"wrap_notialert"}>
                                <input type="radio" id="chat_off" name="chat-alert" checked={chatAlert === 0} onChange={(e)=>this.radioHandle(e, 0)} />
                                <label htmlFor="chat_off" >Off</label>
                                <input type="radio" id="chat_on" name="chat-alert" checked={chatAlert === 1} onChange={(e)=>this.radioHandle(e, 1)} />
                                <label htmlFor="chat_on" >On</label>
                            </div>
                        </li>
                        <li>
                            <p>Red Flag</p>
                            <div className={"wrap_notialert"}>
                                <input type="radio" id="rflag_off" name="red_flag" checked={redFlag === 0} onChange={(e)=>this.radioHandle(e, 0)} />
                                <label htmlFor="rflag_off" >Off</label>
                                <input type="radio" id="rflag_on" name="red_flag" checked={redFlag === 1} onChange={(e)=>this.radioHandle(e, 1)} />
                                <label htmlFor="rflag_on" >On</label>
                            </div>
                        </li>
                        <li>
                            <p>Posting</p>
                            <div className={"wrap_notialert"}>
                                <input type="radio" id="posting_off" name="postings" checked={posting === 0} onChange={(e)=>this.radioHandle(e, 0)} />
                                <label htmlFor="posting_off" >Off</label>
                                <input type="radio" id="posting_on" name="postings" checked={posting === 1} onChange={(e)=>this.radioHandle(e, 1)} />
                                <label htmlFor="posting_on" >On</label>
                            </div>
                        </li>
                        <li>
                            <p>Chat</p>
                            <div className={"wrap_notialert"}>
                                <input type="radio" id="chat_inactive" name="chat" checked={chatVal === 0} onChange={(e)=>this.radioHandle(e, 0)} />
                                <label htmlFor="chat_inactive" >Inactive</label>
                                <input type="radio" id="chat_active" name="chat" checked={chatVal === 1} onChange={(e)=>this.radioHandle(e, 1)} />
                                <label htmlFor="chat_active" >Active</label>
                            </div>
                        </li>
                        <li>
                            <p>Ban User</p>
                            <div className={"wrap_notialert"}>
                                <input type="radio" id="banning_no" name="ban" checked={banUser === 0} onChange={(e)=>this.radioHandle(e, 0)} />
                                <label htmlFor="banning_no" >No</label>
                                <input type="radio" id="banning_yes" name="ban" checked={banUser === 1} onChange={(e)=>this.radioHandle(e, 1)} />
                                <label htmlFor="banning_yes" >Yes</label>
                            </div>
                        </li>
                    </ul>
                    <ul className="noti_ul">
                        <li>
                            <p>Total Paid</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>$2332/27</p>
                            </div>
                        </li>
                        <li>
                            <p>Total Chats</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>13</p>
                            </div>
                        </li>
                        <li>
                            <p>Red Keywords</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>14</p>
                            </div>
                        </li>
                        <li>
                            <p>Reports</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>15</p>
                            </div>
                        </li>

                    </ul>
                </div>
                <div className="status_bWrap">
                    <ul className="noti_ul noti_ul2">
                        <li>
                            <p>Total Jobs</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>{amountData && countData? `$${amountData[0].all_count}/${countData[0].all_count}`:'$0/0'}</p>
                            </div>
                        </li>
                        <li>
                            <p>Completed</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>{amountData && countData? `$${amountData[0].completed_count}/${countData[0].completed_count}`:'$0/0'}</p>
                            </div>
                        </li>
                        <li>
                            <p>In Progress</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>{amountData && countData? `$${amountData[0].inprogress_count}/${countData[0].inprogress_count}`:'$0/0'}</p>
                            </div>
                        </li>
                        <li>
                            <p>Waiting for deposit</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>{amountData && countData? `$${amountData[0].waiting_deposit_count}/${countData[0].waiting_deposit_count}`:'$0/0'}</p>
                            </div>
                        </li>
                        <li>
                            <p>Bidding</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>{amountData && countData? `$${amountData[0].bidding_count}/${countData[0].bidding_count}`:'$0/0'}</p>
                            </div>
                        </li>
                        <li>
                            <p>No-Bidding</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>$0/0</p>
                            </div>
                        </li>
                        <li>
                            <p>Canceled</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>{amountData && countData? `$${amountData[0].cancel_count}/${countData[0].cancel_count}`:'$0/0'}</p>
                            </div>
                        </li>
                        <li>
                            <p>Refund</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>{amountData && countData? `$${amountData[0].refund_count}/${countData[0].refund_count}`:'$0/0'}</p>
                            </div>
                        </li>
                        
                    </ul>
                </div>
                <div className="status_bWrap">
                    <ul className="noti_ul noti_ul2 mar_0">
                        <li>
                            <p>Rated me</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>{reviewsData !== null?reviewsData.rated_me:0} Reviews</p>
                            </div>
                        </li>
                        <li>
                            <p>I Rated</p>
                            <div className={"wrap_notialert min_width"}>
                                <p>{reviewsData !== null?reviewsData.i_rated:0} Clients</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default withRouter(connect(null)(StatusDetails));
